module.exports = __webpack_public_path__ + "media/images/vp/icon.rightarrow2.red-11079c43e2b455f743dd32dc6b9bea02.svg";